import { Col, Row } from "antd";
import type { FC } from "react";
import styled from "styled-components";

import { TextInput } from "../../../Form/formComponents";

export interface TableSearchBarProps {
    value?: string;
    onChange: (value?: string) => void;
    placeholder?: string;
}

export const TableSearchBar: FC<TableSearchBarProps> = ({ value, onChange, placeholder = "Search" }) => (
    <StyledSearchRow>
        <Col span={10}>
            <TextInput value={value} onChange={onChange} placeholder={placeholder} />
        </Col>
    </StyledSearchRow>
);

const StyledSearchRow = styled(Row)`
    display: flex;
    justify-content: flex-end;
`;
